import classNames from 'classnames';

import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';

import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCheckCircle, faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const rootCss = ({ palette, spacing }) => ({
  display: 'flex',
  margin: spacing('2px', 2, '2px', 0),
  maxWidth: 150,
  flex: '0 0 20%',
  '.SSCT-timeline': {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 0,
    marginRight: spacing(1),
    '& + *': { alignSelf: 'center' },
  },
  '.SSCT-dashedLine': {
    flex: 1,
    borderLeft: `4px dashed ${palette.grey[400]}`,
    // backgroundImage: `linear-gradient(${palette.grey[400]} 50%, rgba(255,255,255,0) 0%)`,
    // backgroundPosition: 'right',
    // backgroundSize: '100% 20px',
    // backgroundRepeat: 'repeat-y',
    // width: 4,
  },
  '.SSCT-dashedLine_noBorder': {
    borderLeft: 'none',
    // background: 'none'
  },
  '.SSCT-circleCheckIcon': {
    color: palette.primary.main,
  },
  '.SSCT-circleIcon': {
    color: palette.grey[400],
  },
  '.SSCT-arrowIcon': {
    color: palette.grey[400],
    position: 'absolute',
  },
});

export default function StudySessionCardTimeline({ arrow, first, isToday, last, loading, text }) {
  return (
    <div css={rootCss}>
      <div className="SSCT-timeline">
        {first && arrow && (
          <FontAwesomeIcon className="SSCT-arrowIcon" icon={faChevronUp} size="2x" style={{ top: -15 }} />
        )}
        <div
          className={classNames('SSCT-dashedLine', {
            'SSCT-dashedLine_noBorder': first && !arrow,
          })}
        ></div>

        <FontAwesomeIcon
          className={isToday ? 'SSCT-circleCheckIcon' : 'SSCT-circleIcon'}
          icon={isToday ? faCheckCircle : faCircle}
          size="2x"
        />

        <div
          className={classNames('SSCT-dashedLine', {
            'SSCT-dashedLine_noBorder': last && !arrow,
          })}
        ></div>
        {last && arrow && (
          <FontAwesomeIcon className="SSCT-arrowIcon" icon={faChevronDown} size="2x" style={{ bottom: -15 }} />
        )}
      </div>
      {loading ?
        <Skeleton variant="text" width={75}></Skeleton>
      : <Typography sx={{ color: isToday ? 'primary.main' : 'text.secondary' }} variant="subtitle2">
          {text}
        </Typography>
      }
    </div>
  );
}
